// istanbul ignore file
import { Validate } from '@deporvillage/utils-library-component';

const CustomerNoGender = {
    firstName: {
        id: 'firstName',
        type: 'text',
        label: 'form.label.first_name',
        value: null,
        error: null,
        validate: [Validate.required, Validate.maxLength20],
    },
    lastName: {
        id: 'lastName',
        type: 'text',
        label: 'form.label.last_name',
        value: null,
        error: null,
        validate: [Validate.required, Validate.maxLength40],
    },
    email: {
        id: 'email',
        type: 'email',
        label: 'form.label.email',
        value: null,
        error: null,
        validate: [Validate.email],
    },
    password: {
        id: 'password',
        type: 'password',
        label: 'form.label.password',
        value: null,
        error: null,
        validate: [Validate.required, Validate.password],
    },
    passwordConfirmation: {
        id: 'passwordConfirmation',
        type: 'password',
        label: 'form.label.password_confirmation',
        value: null,
        error: null,
        validate: [Validate.required, Validate.passwordConfirmation],
    },
    isAccepted: {
        id: 'isAccepted',
        type: 'checkbox',
        label: 'form.generic.terms',
        value: false,
        validate: [Validate.required],
    },
};
export default CustomerNoGender;
